const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  permissions: state => state.user.permissions,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  cashHistory: state => state.pageHistory.cashHistory,
  aliveRouters: state => state.aliveRouter.aliveRouters,
  noAliveRouter: state => state.aliveRouter.noAliveRouter,
  routeMatched: state => state.aliveRouter.routeMatched
}

export default getters
